import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M9 13.714a4.714 4.714 0 1 0 0-9.428 4.714 4.714 0 0 0 0 9.428M9 15A6 6 0 1 0 9 3a6 6 0 0 0 0 12",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M9 8c.414 0 .75.28.75.625v3.75c0 .345-.336.625-.75.625s-.75-.28-.75-.625v-3.75C8.25 8.28 8.586 8 9 8",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "9",
  cy: "6",
  r: ".5",
  stroke: "#797979"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-info"}) } }